import { Navigate, Route, Routes, ScrollRestoration } from 'react-router-dom';
import PageLayout from 'layout/PageLayout';
import NetworkRequiredRoutes from 'components/networkRequiredRoutes';
import { LegalDocument } from '../LegalDocument';
import TermsOfUse from '../moks/TermOfUseMokc';
import PolicyMock from '../moks/PolicyMock';
import AppointmentCancellation from '../moks/AppointmentCancellation';
import NoticeOfPrivacyPractices from '../moks/NoticeOfPrivacyPractices';
import NoticeOfPrivacyPracticesSudRecords from '../moks/NoticeOfPrivacyPracticesSudRecords';
import ConsentToUseAndDiscloseSubstance from '../moks/ConsentToUseAndDiscloseSubstance';
import React from 'react';

export const LegalDocumentRoutes = () => {
  return (
    <PageLayout className="bg-base-content">
      <NetworkRequiredRoutes>
        <Routes>
          <Route path="/:id" element={<LegalDocument />} />
          <Route path="/term" element={<TermsOfUse />} />
          <Route path="/policy" element={<PolicyMock />} />
          <Route path="/notice" element={<NoticeOfPrivacyPractices />} />
          <Route path="/cancel" element={<AppointmentCancellation />} />
          <Route
            path="/substance"
            element={<ConsentToUseAndDiscloseSubstance />}
          />
          <Route
            path="/sud-patient"
            element={<NoticeOfPrivacyPracticesSudRecords />}
          />
          <Route path="/*" element={<Navigate to="/" />} />
        </Routes>
      </NetworkRequiredRoutes>
      <ScrollRestoration />
    </PageLayout>
  );
};
